import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  ADD_TEAMMATE,
  CREATE_ACCOUNT,
  DOWNLOAD_RECORDER,
  FIRST_VIDEO_RECORDING,
  FIRST_VIDEO_VIEWED,
  GET_STARTED_CHECKLIST,
  SHARE_VIDEO,
} from 'constants/checklist';

import {
  selectUserHasUsedDesktop,
  selectUserHasUsedExtension,
} from 'selectors/user';

export function useGetCheckListStatus() {
  const firstVideoRecorded = useSelector(
    state => state.checklist.first_video_recording
  );
  const firstVideoHasBeenViewed = useSelector(
    state => state.checklist.first_video_viewed
  );
  const hasSharedVideo = useSelector(state => state.checklist.share_video);
  const hasAddedTeammate = useSelector(state => state.checklist.add_teammate);
  const hasDownloadedRecorder = useSelector(
    state => state.checklist.download_recorder
  );
  const hasUsedDesktopApp = useSelector(selectUserHasUsedDesktop);
  const hasUsedExtension = useSelector(selectUserHasUsedExtension);

  const downloadRecorderComplete =
    hasDownloadedRecorder || hasUsedDesktopApp || hasUsedExtension;
  const firstVideoRecordingComplete = firstVideoRecorded;
  const shareVideoComplete = hasSharedVideo;
  const firstVideoViewedComplete = firstVideoHasBeenViewed;
  const addTeammateComplete = hasAddedTeammate;

  return useMemo(
    () => ({
      [CREATE_ACCOUNT]: true,
      [DOWNLOAD_RECORDER]: downloadRecorderComplete,
      [FIRST_VIDEO_RECORDING]: firstVideoRecordingComplete,
      [SHARE_VIDEO]: shareVideoComplete,
      [FIRST_VIDEO_VIEWED]: firstVideoViewedComplete,
      [ADD_TEAMMATE]: addTeammateComplete,
    }),
    [
      downloadRecorderComplete,
      firstVideoRecordingComplete,
      shareVideoComplete,
      firstVideoViewedComplete,
      addTeammateComplete,
    ]
  );
}

export function useGetChecklistCompletionPercentage() {
  const status = useGetCheckListStatus();

  const percentComplete = Math.ceil(
    (GET_STARTED_CHECKLIST.filter(item => status[item]).length /
      GET_STARTED_CHECKLIST.length) *
      100
  );

  return percentComplete;
}

export function useGetChecklistHasViewedVideos() {
  const hasViewedVideos = useSelector(
    state => state.checklist.has_viewed_videos
  );

  return hasViewedVideos;
}
